const updateActionsStore = {
  toastr: 'Ação atualizada',
  toastrError1: 'Não autorizado (Criado por outro usuário)',
  toastrError2: 'Não autorizado (Você não é um dos responsáveis)',
  toastrError3: 'Não autorizado',
};

export default updateActionsStore;
